import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SwitchOnOffToggle from './../../reusable/Form/SwitchOnOffToggle';

export default class SectionOnOffToggleWrapper extends Component {

    static propTypes = {
        isSectionActive: PropTypes.bool,
        saveData:        PropTypes.func,
        saveDataField:   PropTypes.string, //key to update in the data object
        dottedBorder:    PropTypes.bool,
        sectionId:       PropTypes.string //unique id for QA automation
    };

    static defaultProps = {
        isSectionActive: true
    };

    constructor(props) {
        super(props);

        this.state = {
            isSectionActive: this.props.isSectionActive
        };

        this.toggleSectionVisibility = this.toggleSectionVisibility.bind(this);
    }

    toggleSectionVisibility() {
        this.setState({isSectionActive: !this.state.isSectionActive});

        if (this.props.saveData) {
            this.props.saveData({[this.props.saveDataField]: !this.state.isSectionActive});
        }

    }

    render() {
        return (
            <div className={"section-on-off-wrapper" + (this.props.dottedBorder ? '' : ' no-border')}>

                <SwitchOnOffToggle isSwitchOn={this.state.isSectionActive}
                                   onToggle={this.toggleSectionVisibility}
                                   labelI18n={this.state.isSectionActive ?
                                       "General_CoreFunctionality_UIText_general.on" :
                                       "General_CoreFunctionality_UIText_general.off"}
                                   labelId={this.props.sectionId} />

                <div className={'on-off-toggle__animation' + (this.state.isSectionActive ? ' slide-out' : ' slide-in')}>
                    {this.props.children ? this.props.children : null}
                </div>

            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsCreate/SectionOnOffToggleWrapper.jsx